import { select, call } from 'redux-saga/effects';
import loginRedirectUrl from 'helpers/loginRedirectUrl';
import { isLoggedIn as stateIsLoggedIn } from 'redux/modules/user';
import { isLoggedIn as sagaSelectorIsLoggedIn } from 'redux/saga/selectors';

export const isLoggedIn = store => new Promise(resolve => resolve(stateIsLoggedIn(store.getState())));

export default function* requireLoggedIn(nextState, replaceState, forceTo) {
  if (!(yield select(sagaSelectorIsLoggedIn))) {
    return yield call(replaceState, forceTo || loginRedirectUrl(nextState.location));
  }
}
